import { Box } from "@mui/material";
import { PieChart } from "@mui/x-charts";

const TestCasesCharts = ({ testCasesData, testCasesTotal, draftTestCases }) => {
    const draftPercent = (
        (draftTestCases.length / testCasesTotal) *
        100
    ).toFixed(2);

    const inProgressTotal = testCasesData.filter(
        (testCase) => testCase.status === "RUNNING"
    ).length;
    const inProgressPercent = (
        (inProgressTotal / testCasesTotal) *
        100
    ).toFixed(2);

    const failedTotal = testCasesData.filter(
        (testCase) =>
            testCase.status === "FAILED" ||
            testCase.status === "INITIAL_FAILURE"
    ).length;
    const failedPercent = ((failedTotal / testCasesTotal) * 100).toFixed(2);

    const passedTotal = testCasesData.filter(
        (testCase) => testCase.status === "COMPLETED"
    ).length;
    const passedPercent = ((passedTotal / testCasesTotal) * 100).toFixed(2);

    const executionData = [
        { label: "Executed", value: 100 - draftPercent, color: "#ab47bc" },
        { label: "Not Started", value: draftPercent, color: "#78909c" },
    ].filter((item) => Number(item.value) > 0);

    const statusData = [
        { label: "Passed", value: passedPercent, color: "#388e3c" },
        { label: "In Progress", value: inProgressPercent, color: "#2196f3" },
        { label: "Failed", value: failedPercent, color: "#d32f2f" },
        { label: "Draft", value: draftPercent, color: "#bdbdbd" },
    ].filter((item) => Number(item.value) > 0);

    return (
        <Box className="testCasesTabDetailsChartsContainer">
            <Box className="testCasesTabDetailsCharts">
                <Box>
                    <PieChart
                        series={[
                            {
                                innerRadius: 75,
                                outerRadius: 100,
                                data: executionData,
                                paddingAngle: 4,
                                valueFormatter: (item) => `${item.value}%`,
                            },
                        ]}
                        width={460}
                        height={240}
                        slotProps={{
                            legend: {
                                itemGap: 30,
                            },
                        }}
                    />
                </Box>
                <Box>
                    <PieChart
                        series={[
                            {
                                innerRadius: 75,
                                outerRadius: 100,
                                data: statusData,
                                paddingAngle: 4,
                                valueFormatter: (item) => `${item.value}%`,
                            },
                        ]}
                        width={460}
                        height={240}
                        slotProps={{
                            legend: {
                                itemGap: 30,
                            },
                        }}
                    />
                </Box>
            </Box>
        </Box>
    );
};

export default TestCasesCharts;
